/*
  KP: THE LIST OF BUNDLES shown in the "Bundles" tab on phone case pages.
  This is the only file to edit to add, change or remove a bundle. The tab itself is
  assets/kp-bundles.js (which reads this list) and assets/kp-bundles.css.
  Loaded by snippets/theme-globals.liquid, just before kp-bundles.js.

  Each bundle is the phone case plus other items. What can be set on a bundle:
    - id: '...'         a short name of your own, different for every bundle.
    - name: '...'       the title on the card.
    - text: '...'       the line under the title.
    - badge: '...'      a strip across the top of the card ("Most popular"). Optional.
                        {save} in it becomes what the bundle saves for the case being looked
                        at ("Save {save}" shows "Save £22.32"). Keep badges true: a "Best
                        seller" or "Biggest saving" claim has to match the orders and prices.
    - caseType: '...'   use this case type instead of the one chosen on the page (the
                        Magnetic Bundle uses the MagSafe case). Optional.
    - caseFallback: true
                        when the chosen model does not come in that case type, still
                        offer the bundle, with the case as chosen on the page. Without
                        this, the bundle is left out for such models.
    - textWithoutMagsafe: '...'
                        the line under the title when the case in the bundle is not a
                        MagSafe case.
    - items: [...]      the other things in the bundle (see "An item" below).
    - itemsWithoutMagsafe: [...]
                        a different set of items, used INSTEAD of "items" when the phone
                        model chosen does not come in a MagSafe case at all (so nothing
                        magnetic is offered for it). Optional.
    - textModelWithoutMagsafe: '...'
                        the line under the title when that other set is used.
    - build: { min: 3 } makes it a BUILD YOUR OWN bundle: no "items" list. The card shows
                        the case as chosen on the page, then every matching item for that
                        case (all of its complementary products in the Search & Discovery
                        app) with a tick box each. "min" is how many things must be in
                        the bundle, the case included, before the discount comes on (3
                        means the case and two ticked items). It must be the same number
                        as the rule in Selleasy. A case with too few matching items to
                        reach the minimum does not get this bundle.
    - discount: {...}   see below. Without it the items are added at their normal prices.
    - pair: true        makes it a CASE + CASE bundle: no "items" list. The case as chosen on
                        the page plus a second case of any design, picked from every phone
                        case (best sellers first). The half price comes from the store's
                        automatic Buy 1 Get 1 Half Price, so it has no "discount".
    - tag: '...'        the red label beside the name, for a bundle with no "discount".
    - inline: true      not a card in the Bundles tab. Used for Case + case, which opens
                        under Add to Cart instead (the "Add a 2nd case, half price" line).

  An item is one of:
        match: '...'    an item in the SAME DESIGN as the case: the first of the case's
                        complementary products (Search & Discovery app) whose name
                        contains these words.
        handle: '...'   a fixed product, the same for every case (its web address name).
                        Given together with "match", it is the stand-in used when the
                        case has no complementary product of that kind.
      If an item cannot be found either way, the whole bundle is left out for that case.
      Also, on any item:
        follow: 'Model' take the item in the phone model chosen on the page; if it does
                        not come in that model, the bundle is left out.
        prefer: '...'   which of the item's options to start on (its exact option name).
        preferWithoutMagsafe: '...'
                        which option to start on instead when the case in the bundle is
                        not a MagSafe case.
        label: '...'    the short name shown for the item.

  DISCOUNT. A bundle's discount is borrowed from an offer set up in the Selleasy app.
  Each Selleasy offer has a discount in Shopify admin > Discounts (for example
  "MAGNETIC BUNDLE" or "EVERYDAYBUNDLE#f7fc") with its own rule: so many items bought
  together, so many per cent off. Selleasy's own widget marks each item it adds with a
  hidden line property, "_lb-product", holding the case's product number and the first
  part of the offer's number, and puts the discount's code on the cart; the discount then
  comes off the marked items. The Bundles tab does the same two things, using:
    - code:     the discount's code, EXACTLY as it is in Shopify admin > Discounts. If the
                code is renamed there, it must be changed here too, or the bundle is
                added at full price.
    - offer:    "offer#" and the first eight characters of the Selleasy offer's number.
    - property: always "_lb-product".
    - percent:  ONLY what is SHOWN on the card. It does not set the discount, and must be
                kept the same as the rule in Selleasy.
  The rule counts the marked items, so a bundle must have at least as many items as the
  rule asks for (the case counts as one). A rule of "3 items" also applies to 4, 5 or
  more marked items (tested in the cart on 8 Oct 2026 with "BUILD A BUNDLE#bb60"), and
  gives nothing at 2.
  This copies how Selleasy's widget behaves; it is not a documented feature. If Selleasy
  changes it, or a discount is switched off, renamed or has its rule changed, the bundle
  is added at full price while the card still shows the saving. Test in the cart after
  any change. To put a bundle back to full price, delete its "discount" line.

  The codes, offer numbers and rules below were read from Shopify admin > Discounts on
  12 Oct 2026 (each Selleasy discount stores its offer number and rule):
    MAGNETIC BUNDLE       offer 8ebbde81   3 items, 15%
    EssentialBUNDLE#a603  offer 09150fcf   2 items, 15%
    EVERYDAYBUNDLE#f7fc   offer 0cd72e80   3 items, 15%
    ULTIMATE#6c1c         offer d3bc94b9   5 items, 20%
    Sip&Scroll#5e55       offer ac7b60fe   2 items, 10%
    BUILD A BUNDLE#bb60   offer d10413f1   3 items, 15%
  Not on this tab (no phone case in them, they are for the gifts page): onthego#babc
  (power bank + water bottle, 2 items, 15%, offer 31da9238) and anyphone#f6a6 (power
  bank + ring holder with metal mount + wrist strap, 3 items, 15%, offer 2747b879).

  NOT ON THE TAB (Sana's choice, 12 Oct 2026: the product page shows only Magnetic,
  Everyday and Build your own). These are ready to paste back into the list below if
  wanted; their Selleasy offers are live:
      {
        id: 'essential',
        name: 'The Essential Bundle',
        text: 'Your MagSafe case with the matching power bank.',
        // MagSafe models only: the power bank needs a magnetic case.
        caseType: 'Magsafe Tough Case',
        // Selleasy offer 09150fcf: 15% off when 2 items are bought together.
        discount: { percent: 15, code: 'EssentialBUNDLE#a603', property: '_lb-product', offer: 'offer#09150fcf' },
        items: [
          { match: 'Power Bank', label: 'Magnetic Power Bank', prefer: 'Power Bank & Shell' }
        ]
      },
      {
        id: 'ultimate',
        name: 'The Ultimate Bundle',
        badge: 'Best value',
        text: 'Your MagSafe case with the matching power bank, ring holder and wallet, plus a crossbody strap.',
        // MagSafe models only: power bank, ring holder and wallet are all magnetic.
        caseType: 'Magsafe Tough Case',
        // Selleasy offer d3bc94b9: 20% off when 5 items are bought together.
        discount: { percent: 20, code: 'ULTIMATE#6c1c', property: '_lb-product', offer: 'offer#d3bc94b9' },
        items: [
          { match: 'Power Bank', label: 'Magnetic Power Bank', prefer: 'Power Bank & Shell' },
          { match: 'Ring Holder', label: 'Magnetic Ring Holder', prefer: 'Magnetic Ring Holder' },
          { match: 'Wallet', label: 'Magnetic Wallet' },
          { handle: 'phone-strap', label: 'Phone Strap', prefer: 'Black crossbody strap' }
        ]
      },
      {
        id: 'sip',
        name: 'The Sip & Scroll Bundle',
        text: 'Your case with the matching water bottle.',
        // Selleasy offer ac7b60fe: 10% off when 2 items are bought together.
        discount: { percent: 10, code: 'Sip&Scroll#5e55', property: '_lb-product', offer: 'offer#ac7b60fe' },
        items: [
          { match: 'Water Bottle', label: 'Water Bottle' }
        ]
      },

  REMOVED on 16 Oct 2026 (Sana: "remove it all together"): CASE + CASE, the case plus a 2nd
  case of any design at half price (store's Buy 1 Get 1 Half Price, no code). With it gone
  there is no "Add a 2nd case, half price" line under Add to Cart and no card in the tab.
  To bring it back, paste into the list below ("inline: true" = only the line under Add to
  Cart, which opens the 2nd case picker there; without it, a card in the Bundles tab):
    { id: 'pair', name: 'Case + case',
      text: 'Pick any second design. Your 2nd case is half price.',
      tag: '2nd half price', pair: true, inline: true },
  and put back the space held for the line in snippets/kp-extras.liquid part 14
  (padding-top: 77px on the "Tax included" line).

  REMOVED on 8 Oct 2026: The Artist Bundle (phone case + matching iPad case, 10% off 2
  items, Selleasy offer 5d480d9f, code 'ARTIST BUNDLE#5ee7'). To bring it back, add:
    { id: 'artist', name: 'The Artist Bundle',
      text: 'Matching cases for your phone and your iPad.',
      discount: { percent: 10, code: 'ARTIST BUNDLE#5ee7', property: '_lb-product', offer: 'offer#5d480d9f' },
      items: [{ match: 'iPad Case', label: 'iPad Case' }] }
*/
window.KP_BUNDLES = [
  {
    id: 'magnetic',
    name: 'The Magnetic Bundle',
    // "Best seller" (16 Oct 2026, Sana): true across all bundle orders, the MAGNETIC BUNDLE
    // code is on 19 orders since July (Everyday 1, Build your own 3). Was briefly no badge,
    // and before that "Save {save}".
    badge: 'Best seller',
    text: 'Your MagSafe case with the matching power bank and ring holder.',
    textWithoutMagsafe: 'Your case with the matching power bank and a ring holder with metal mount.',
    caseType: 'Magsafe Tough Case',
    caseFallback: true,
    // Selleasy offer 8ebbde81: 15% off when 3 items are bought together.
    discount: { percent: 15, code: 'MAGNETIC BUNDLE', property: '_lb-product', offer: 'offer#8ebbde81' },
    items: [
      { match: 'Power Bank', label: 'Magnetic Power Bank', prefer: 'Power Bank & Shell' },
      { match: 'Ring Holder', label: 'Magnetic Ring Holder', prefer: 'Magnetic Ring Holder', preferWithoutMagsafe: 'Magnetic Ring Holder + Metal Mount' }
    ]
  },
  {
    id: 'everyday',
    name: 'The Everyday Bundle',
    text: 'Your MagSafe case with a crossbody strap and the matching wallet.',
    textModelWithoutMagsafe: 'Your case with a crossbody strap and the matching water bottle.',
    // The wallet is magnetic, so the case is the MagSafe one. Models with no MagSafe case
    // get the case as chosen, with a water bottle instead of the wallet.
    caseType: 'Magsafe Tough Case',
    caseFallback: true,
    // Selleasy offer 0cd72e80: 15% off when 3 items are bought together.
    discount: { percent: 15, code: 'EVERYDAYBUNDLE#f7fc', property: '_lb-product', offer: 'offer#0cd72e80' },
    items: [
      { handle: 'phone-strap', label: 'Phone Strap', prefer: 'Black crossbody strap' },
      { match: 'Wallet', label: 'Magnetic Wallet' }
    ],
    // To use one fixed bottle when a case has none, add handle: '...' (the bottle's web
    // address name) to the second item.
    itemsWithoutMagsafe: [
      { handle: 'phone-strap', label: 'Phone Strap', prefer: 'Black crossbody strap' },
      { match: 'Water Bottle', label: 'Water Bottle' }
    ]
  },
  {
    id: 'build',
    name: 'Build your own',
    text: 'Your case plus any 2 or more matching items.',
    // Selleasy offer d10413f1: 15% off when 3 or more items are bought together.
    build: { min: 3 },
    discount: { percent: 15, code: 'BUILD A BUNDLE#bb60', property: '_lb-product', offer: 'offer#d10413f1' }
  }
];
